function getSmallplugPreviewBaseUrl(): URL | null {
  try {
    if (ENV === 'production' || typeof window === 'undefined' || !window.location) return null;
    const searchParams = new URLSearchParams(window.location.search);
    const override = searchParams.get('preview');
    return new URL(override);
  } catch {
    return null;
  }
}

export function getMiddleFrameURL(gatewayName: string): string {
  return `${MIDDLE_FRAME_URL}?gateway=${gatewayName}#${TIMESTAMP}`;
}

export function getSmallPlugHost(gatewayName: string): string {
  /**
   TESTCODE - used for local development
   return `https://local.smallcase.com`;
   */

  /** If in preview mode, return the preview URL */
  const previewUrl = getSmallplugPreviewBaseUrl();
  if (previewUrl) {
    return previewUrl.origin;
  }

  return `https://${gatewayName}.smallcase.com`;
}

export function getSmallPlugIframeURL(
  gatewayName: string,
  path: string,
  params: string,
  themeColor: string,
): string {
  /**
  TESTCODE - used for local development
  return `https://local.smallcase.com/${path ?? ''}?ptname=${gatewayName}&ct=smallplug_web&${
    params ?? ''
  }`;
  */

  const finalPath = `${path ?? ''}?ct=smallplug_web&color=${encodeURIComponent(themeColor)}&${params ?? ''}`;

  /** If in preview mode, return the preview URL */
  const previewUrl = getSmallplugPreviewBaseUrl();
  if (previewUrl) {
    return `${previewUrl.origin}/${finalPath}`;
  }

  // Format of the URL is always going to be "<gatewayname>.smallcase.com"
  return `https://${gatewayName}.smallcase.com/${finalPath}`;
}

export enum ConnectStatus {
  CONNECTED = 'CONNECTED',
  SAM_CONNECTED = 'SAM_CONNECTED',
  GUEST = 'GUEST',
}

export const LEPRECHAUN_SUFFIX = '-leprechaun';
